export default "__VITE_ASSET__C9$Uv5an__"